var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.fullyLoaded)?_c('Loading'):_c('ChemicalForm',{attrs:{"chemicalTypes":_vm.chemicalTypes,"chemicalManufacturers":_vm.chemicalManufacturers,"submit":_vm.submit,"cancel":_vm.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }